module.exports = __webpack_public_path__ + "static/media/card-profile4-square.1a164917.jpg";